import { isPlatformBrowser, NgClass } from '@angular/common';
import {
  AfterViewInit,
  APP_ID,
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  inject,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  GuardsCheckEnd,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
  RouterOutlet,
} from '@angular/router';
import { ENVIRONMENT_URLS_CONFIG_TOKEN } from 'app-initialization';
import { UserService } from 'auth-data-access';
import { BrandService } from 'brand';
import { LoadingComponent } from 'loading';
import { MenuGlobalComponent } from 'menu';
import { NgxSprinklrWebwidgetService } from 'sprinklr-webwidget';
import { ToastsComponent } from 'toast';
import { TooltipGlobalComponent } from 'tooltip';
import { appendNoScriptGoogleTagManager, appendScript } from 'utils';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [ToastsComponent, MenuGlobalComponent, TooltipGlobalComponent, NgClass, RouterOutlet, LoadingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  private router = inject(Router);
  private userService = inject(UserService);
  private matDialog = inject(MatDialog);
  private platformId = inject(PLATFORM_ID);
  private appId = inject(APP_ID);
  private document = inject<Document>(DOCUMENT);
  private config = inject(ENVIRONMENT_URLS_CONFIG_TOKEN);
  private sprinklrService = inject(NgxSprinklrWebwidgetService);
  public brand = inject(BrandService);
  public loading = signal(true);

  constructor() {
    const platform = isPlatformBrowser(this.platformId) ? 'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${this.appId}`);

    this.router.events.subscribe(resp => {
      if ((resp as RouterEvent)?.id === 1) {
        this.loading.set(false);
        return;
      }

      if (resp instanceof NavigationStart) {
        this.matDialog.closeAll();
      }
      if (resp instanceof GuardsCheckEnd) {
        this.loading.set(true);
      }
      if (resp instanceof NavigationEnd) {
        this.loading.set(false);
        this.setPromoClass(resp);
      }
      if (resp instanceof NavigationCancel) {
        this.loading.set(false);
      }
      if (resp instanceof NavigationError) {
        this.loading.set(false);
      }
    });

    //set visitor_id for analytics if there is no visitor_id
    const visitorId = this.userService.getVisitorId();
    if (!visitorId) {
      this.userService.setVisitorId();
    }

    if (isPlatformBrowser(this.platformId)) {
      this.userService.getSubscriptions().subscribe(); // get subscriptions just to set the previously logged in cookie
      this.sprinklrService.init();
    } else {
      appendNoScriptGoogleTagManager(this.document, environment.googleTagManagerId);
    }
  }

  public ngAfterViewInit() {
    const prismicRepo = this.config.prismicRepo;
    appendScript(this.document, `https://static.cdn.prismic.io/prismic.js?new=true&repo=${prismicRepo}`);
  }

  public setPromoClass(e: NavigationEnd) {
    if (/^(\/(en|de|fr|it))?\/blackfriday(\/.+)?/.test(e.urlAfterRedirects)) {
      this.document.body.classList.add('blackfriday');
    } else {
      this.document.body.classList.remove('blackfriday');
    }
  }
}
